import React from 'react';
import { MoreHoriz } from '@mui/icons-material';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import translate from '@/lib/intl/translate';

const MenuButton = React.forwardRef<
  HTMLButtonElement,
  Omit<IconButtonProps, 'size'>
>((props, ref) => (
  <IconButton
    {...props}
    size="large"
    ref={ref}
    aria-label={translate('TOGGLE_MENU')}
  >
    <MoreHoriz />
  </IconButton>
));

export default MenuButton;
